import React, { useState, useEffect } from 'react';
import { getFirestore, getDocs, collection } from 'firebase/firestore';

const Portal = () => {
	// const [ password, setPassword ] = useState('');

	const [ messages, setMessages ] = useState({});

		useEffect(()=>{
			async function getDataFromFirebase() {
				const db = getFirestore();
				const querySnapshot = await getDocs(collection(db, 'messages'));
				let arr = [];
				querySnapshot.forEach((doc) => {
					arr.push(doc.data());
				});
				setMessages(arr);
			}
			getDataFromFirebase();
		},[]);


	function messageLoop() {
		let arr = [];
		for(let i = 0; i < messages.length; i++){
			arr.push(
				<div key={i} className='mainText' style={{marginBottom:20}}>
					<div>Name: {messages[i].name}</div>
					<div>Subject: {messages[i].subject}</div>
					<div>From: {messages[i].email}</div>
					<div>Message: {messages[i].message}</div>
					<div>sent: {messages[i].date.slice(0,24)}</div>
				</div>
			)
		}
		return arr
	}
	return(
		<div>
			{messageLoop()}
		</div>
	)
}

export default Portal;